// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../../../../css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(function(i){return i[1]});
// Module
___CSS_LOADER_EXPORT___.push([module.id, ".background[data-v-02de1c7a]{fill:#0077b5}.letters[data-v-02de1c7a]{fill:#fff}", ""]);
// Exports
module.exports = ___CSS_LOADER_EXPORT___;
